import React from 'react';
import { Input, Row, Col } from 'antd';

const GAPsSearch = ({ gapsData, searchText, setSearchText, setFilteredData }) => {

  const handleSearch = (value) => {
    setSearchText(value);

    const filtered = gapsData.filter((record) => {
      const matchesAsset = record.dependency_control?.dependency?.asset?.name?.toLowerCase().includes(value.toLowerCase());
      const matchesControl = record.dependency_control?.control?.title.toLowerCase().includes(value.toLowerCase());
      const matchesDependency = record.dependency_control?.dependency?.name?.toLowerCase().includes(value.toLowerCase());
      const matchesName = record.name?.toLowerCase().includes(value.toLowerCase());
      const matchesType = record.status?.toLowerCase().includes(value.toLowerCase());
      const matchesState = record.state?.toLowerCase().includes(value.toLowerCase());
      const matchesIssueInProgress = record.issue_in_progress?.toLowerCase().includes(value.toLowerCase());
      const matchesIssuesFinished = (record.issues_finished || []).some(issue => issue?.toLowerCase().includes(value.toLowerCase()));
      const matchesArea = record.area?.name?.toLowerCase().includes(value.toLowerCase()) ?? false;

      return (
        matchesAsset || 
        matchesControl ||
        matchesDependency || 
        matchesName || 
        matchesType ||
        matchesState ||
        matchesIssueInProgress ||
        matchesIssuesFinished ||
        matchesArea
      );
    });

    setFilteredData(filtered); 
  };

  const handleReset = () => {
    setSearchText(''); 
    setFilteredData(gapsData);
  };

  return (
    <Row justify="start" style={{ marginBottom: 16 }}>
      <Col>
        <Input.Search
          className="search-table"
          placeholder="Buscar GAP"
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          onSearch={handleSearch}
          allowClear
        />
      </Col>
    </Row>
  );
};

export default GAPsSearch;